import React, { useMemo } from 'react'
import { getDayAndMonth, getHour, getMeetingProvider } from '../../../utils'
import { MeetingSourceIcon } from '@/components/dashboard/meetings/MeetingSourceIcon'
import { useNavigate } from 'react-router-dom'
import { ChooseProject } from '@/components/dashboard/meetings/chooseProject'

interface EventProps {
  event: any
}

export function Event({ event }: EventProps) {
  const provider = useMemo(() => getMeetingProvider(event.meeting_url), [event.meeting_url])
  const navigate = useNavigate()

  return (
    <div
      key={event.id}
      className="w-[287px] h-[70px] p-3 bg-white rounded-lg shadow border border-[#e4e4e4] flex items-center gap-3 cursor-pointer hover:shadow-md transition-shadow"
      onClick={(e) => {
        // Only navigate if the click wasn't on the ChooseProject component
        if (!(e.target as HTMLElement).closest('.choose-project')) {
          event.projectId && navigate(`/project/${event.projectId}`)
        }
      }}
    >
      <div className="relative flex-shrink-0">
        <MeetingSourceIcon
          source={event.source ? event.source.toLowerCase() : provider.toLowerCase()}
          width="24"
          height="24"
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-[#3f424a] text-base font-semibold font-['Manrope'] leading-tight truncate">
          {event.name || 'Untitled Meeting'}
        </p>
        <div className="mt-1 flex items-center text-[#62708d] text-[13px] font-medium font-['Manrope'] leading-none">
          {!event.start ? (
            <>
              <p>{getDayAndMonth(new Date(event.created_at))}・</p>
              <p>{getHour(new Date(event.created_at))}</p>
              <p>{event.end ? <span>&nbsp;- {getHour(new Date(event.end))}</span> : ''}</p>
            </>
          ) : (
            <>
              <p>{getDayAndMonth(new Date(event.start))}・</p>
              <p>{getHour(new Date(event.start))}</p>
              <p>{event.end ? <span>&nbsp;- {getHour(new Date(event.end))}</span> : ''}</p>
            </>
          )}
          <p>・</p>
          <div className="choose-project inline-flex items-center" onClick={(e) => e.stopPropagation()}>
            <ChooseProject meeting={event} variant="minimal" />
          </div>
        </div>
      </div>
    </div>
  )
}
